import { logSwallowed } from '@/lib/errors';
// jwt.ts — детерминированная проверка срока JWT (SSoT, единая для всех
// входов: web/PWA/desktop, лаунчер/авто-продолжение).

/**
 * Payload JWT (base64url). ВАЖНО: `atob` НЕ понимает base64url (`-`/`_`) —
 * бросает исключение, и при `catch (e) { logSwallowed(e, 'lib/jwt.ts:6'); }` роли/permissions молча терялись.
 * Здесь base64url приводится к base64. Невалидный токен — null (без admin-дефолтов!).
 */
export function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const part = (token || '').split('.')[1];
    if (!part) return null;
    const base64 = part.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const payload = JSON.parse(atob(padded));
    return payload && typeof payload === 'object' ? payload : null;
  } catch {
    return null;
  }
}

/** JWT не истёк (exp в будущем). Невалидный/истёкший — false. */
export function jwtNotExpired(token: string): boolean {
  const payload = decodeJwtPayload(token);
  if (!payload) return false;
  const exp = Number(payload.exp || 0);
  if (!exp) return false;
  return Date.now() < exp * 1000;
}